import { Component, Input, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-mp-contact-details',
  templateUrl: './mp-contact-details.component.html',
  styleUrls: ['./mp-contact-details.component.css']
})
export class MpContactDetailsComponent {


  @Input() showContactPopup = false;
  @Input() contactData: any;
  @Output() close = new EventEmitter<void>();


  closeContactPopup() {
    this.close.emit();
  }

  /** Build initials from the company name (falls back to contact person). */
  getInitials(): string {
    const source = this.contactData?.companyName || this.contactData?.contactPerson || '';
    const words = source.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) {
      return '?';
    }
    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
}
